import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Base/Layout/index.vue'
import PagesLogin from '@/components/Pages/Login'
import PagesDashboard from '@/components/Pages/Dashboard'
import PagesTopDetail from '@/components/Pages/Top'
import PagesWorks from '@/components/Pages/Works'
import PagesWorksDetail from '@/components/Pages/Works/Detail'
import PagesWorksBDetail from '@/components/Pages/Works/DetailB'
import PagesTalent from '@/components/Pages/Talent'
import PagesTalentDetail from '@/components/Pages/Talent/Detail'
import PagesPress from '@/components/Pages/Press'
import PagesPressDetail from '@/components/Pages/Press/Detail'
import PagesNewsletter from '@/components/Pages/Newsletter'
import PagesNewsletterDetail from '@/components/Pages/Newsletter/Detail'
import PagesStories from '@/components/Pages/Stories'
import PagesStoriesDetail from '@/components/Pages/Stories/Detail'
import PagesStudio from '@/components/Pages/Studio'
import PagesCareers from '@/components/Pages/Careers'
import PagesMargedNews from '@/components/Pages/MargedNews'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/login',
    name: 'PagesLogin',
    component: PagesLogin
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    children: [{
      path: 'dashboard',
      component: PagesDashboard,
      name: 'dashboard',
      meta: { title: 'dashboard' }
    }]
  },
  {
    path: '/top',
    component: Layout,
    name: 'top',
    redirect: 'topDetail',
    meta: {
      title: 'TOPコンテンツ管理'
    },
    children: [
      {path: '', component: PagesTopDetail, name: 'topDetail', meta: { title: '' }}
    ]
  },
  {
    path: '/works',
    component: Layout,
    name: 'works',
    redirect: '/works/',
    meta: {
      title: 'works'
    },
    children: [
      {path: '', component: PagesWorks, name: 'worksList', meta: { title: 'Works List' }},
      {path: 'work1/:id(\\d+)', component: PagesWorksDetail, name: 'worksDetail1', meta: { title: 'Works 編集' }},
      {path: 'work2/:id(\\d+)', component: PagesWorksBDetail, name: 'worksDetail2', meta: { title: 'Works 編集' }},
      {path: 'create_a', component: PagesWorksDetail, name: 'worksCreateA', meta: { title: 'Works A 新規作成' }},
      {path: 'create_b', component: PagesWorksBDetail, name: 'worksCreateB', meta: { title: 'Works B 新規作成' }}
    ]
  },
  {
    path: '/talent',
    component: Layout,
    name: 'talent',
    redirect: '/talent/',
    meta: {
      title: 'talent'
    },
    children: [
      {path: '', component: PagesTalent, name: 'talentList', meta: { title: 'Talent List' }},
      {path: ':id(\\d+)', component: PagesTalentDetail, name: 'talentDetail', meta: { title: 'Talent 編集' }},
      {path: 'create', component: PagesTalentDetail, name: 'talentCreate', meta: { title: 'Talent 新規作成' }}
    ]
  },
  {
    path: '/press',
    component: Layout,
    name: 'press',
    redirect: '/press/',
    meta: {
      title: 'press'
    },
    children: [
      {path: '', component: PagesPress, name: 'pressList', meta: { title: 'Press List' }},
      {path: ':id(\\d+)', component: PagesPressDetail, name: 'pressDetail', meta: { title: 'Press 編集' }},
      {path: 'create', component: PagesPressDetail, name: 'pressCreate', meta: { title: 'Press 新規作成' }}
    ]
  },
  {
    path: '/newsletter',
    component: Layout,
    name: 'newsletter',
    redirect: '/newsletter/',
    meta: {
      title: 'newsletter'
    },
    children: [
      {path: '', component: PagesNewsletter, name: 'newsletterList', meta: { title: 'Newsletter List' }},
      {path: ':id(\\d+)', component: PagesNewsletterDetail, name: 'newsletterDetail', meta: { title: 'Newsletter 編集' }},
      {path: 'create', component: PagesNewsletterDetail, name: 'newsletterCreate', meta: { title: 'Newsletter 新規作成' }}
    ]
  },
  {
    path: '/stories',
    component: Layout,
    name: 'stories',
    redirect: '/stories/',
    meta: {
      title: 'stories'
    },
    children: [
      {path: '', component: PagesStories, name: 'storiesList', meta: { title: 'Stories List' }},
      {path: ':id(\\d+)', component: PagesStoriesDetail, name: 'storiesDetail', meta: { title: 'Stories 編集' }},
      {path: 'create', component: PagesStoriesDetail, name: 'storiesCreate', meta: { title: 'Stories 新規作成' }}
    ]
  },
  {
    path: '/studio',
    component: Layout,
    name: 'studio',
    redirect: '/studio/',
    children: [
      {path: '', component: PagesStudio, name: 'studioDetail', meta: { title: 'Studio 編集' }}
    ]
  },
  {
    path: '/merged_news',
    component: Layout,
    name: 'mergedNews',
    redirect: '/merged_news/',
    meta: {
      title: 'merged_news'
    },
    children: [
      {path: '', component: PagesMargedNews, name: 'mergedNewsList', meta: { title: 'Merged News List' }}
    ]
  },
  {
    path: '/careers',
    component: Layout,
    name: 'careers',
    redirect: '/careers/',
    children: [
      {path: '', component: PagesCareers, name: 'careersDetail', meta: { title: 'Careers 編集' }}
    ]
  }
]

export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js